export default {
    props: {
        pdfArea: {
            type: String,
            default: undefined,
            kComposite: 'pdf.area'
        }, 
        pdfAuthor: {
            type: String,
            default: undefined,
            kComposite: 'pdf.author'
        }, 
        pdfCreator: {
            type: String,
            default: undefined,
            kComposite: 'pdf.creator'
        }, 
        pdfDate: {
            type: Date,
            default: undefined,
            kComposite: 'pdf.date'
        }, 
        pdfFileName: {
            type: String,
            default: undefined,
            kComposite: 'pdf.fileName'
        }, 
        pdfFitWidth: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.fitWidth'
        }, 
        pdfForceProxy: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.forceProxy'
        }, 
        pdfGuidelines: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.guidelines'
        }, 
        pdfHCenter: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.hCenter'
        }, 
        pdfKeywords: {
            type: String,
            default: undefined,
            kComposite: 'pdf.keywords'
        }, 
        pdfLandscape: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.landscape'
        }, 
        pdfMarginBottom: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.bottom'
        }, 
        pdfMarginLeft: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.left'
        }, 
        pdfMarginRight: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.right'
        }, 
        pdfMarginTop: {
            type: [Number, String],
            default: undefined,
            kComposite: 'pdf.margin.top'
        }, 
        pdfPaperSize: {
            type: [String, Array],
            default: undefined,
            kComposite: 'pdf.paperSize'
        }, 
        pdfProxyURL: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyURL'
        }, 
        pdfProxyTarget: {
            type: String,
            default: undefined,
            kComposite: 'pdf.proxyTarget'
        }, 
        pdfSubject: {
            type: String,
            default: undefined,
            kComposite: 'pdf.subject'
        }, 
        pdfTitle: {
            type: String,
            default: undefined,
            kComposite: 'pdf.title'
        }, 
        pdfVCenter: {
            type: Boolean,
            default: undefined,
            kComposite: 'pdf.vCenter'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-spreadsheet-vue-wrapper/src/KendoSpreadsheet/Pdf.js